export default __webpack_public_path__ + "static/media/cancel_w.7280765d.svg";